// extracted by mini-css-extract-plugin
export var label = "_f5-5";
export var slideContainer = "_f5-0";
export var slider = "_f5-1";
export var sliderLg = "_f5-4";
export var sliderMd = "_f5-3";
export var sliderSm = "_f5-2";